var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { RatingBar } from "..";
import defaultUserPicture from "../../assets/default_profile.svg";
var RatingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      display: grid;\n      grid-template-columns: 100%;\n      grid-gap: 1rem;\n      color: ".concat(theme.colorContent(), ";\n      padding: 1rem;\n      border-top: 1px solid ").concat(theme.borderContent(), ";\n    ");
});
var UserDetail = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  align-items: start;\n  justify-content: left;\n  grid-template-columns: auto auto 1fr;\n"], ["\n  display: grid;\n  align-items: start;\n  justify-content: left;\n  grid-template-columns: auto auto 1fr;\n"])));
var UserPicture = styled.picture(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  margin-right: .5rem;\n  grid-row: 1 / 3;\n"], ["\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  margin-right: .5rem;\n  grid-row: 1 / 3;\n"])));
var ReviewDate = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: .75rem;\n  justify-self: right;\n  align-self: start;\n"], ["\n  color: ", ";\n  font-size: .75rem;\n  justify-self: right;\n  align-self: start;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent(.5);
});
var Username = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font-size: .75rem;\n"], ["\n  color: ", ";\n  font-size: .75rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent(.5);
});
var Title = styled.h1(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-weight: bold;\n  font-size: 1rem;\n  color: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  font-weight: bold;\n  font-size: 1rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent();
});
var Description = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  font-size: .8rem;\n"], ["\n  color: ", ";\n  font-size: .8rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent();
});
var Review = function (_a) {
    var rating = _a.rating, title = _a.title, description = _a.description, date = _a.date, user = _a.user;
    return (React.createElement(RatingWrapper, null,
        React.createElement(UserDetail, null,
            React.createElement(UserPicture, null,
                React.createElement("source", { srcSet: user.image }),
                React.createElement("img", { src: defaultUserPicture, alt: "default profile picture" })),
            React.createElement(RatingBar, { rating: rating }),
            React.createElement(ReviewDate, null, date),
            React.createElement(Username, null, user.username)),
        React.createElement(Title, null, title),
        React.createElement(Description, null, description)));
};
export default Review;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
